var React = require('react');

function TwitterIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.144.461c-1.23.724-2.59 1.248-4.038 1.532C24.948.767 23.293 0 21.463 0c-3.51 0-6.358 2.826-6.358 6.31 0 .494.055.975.163 1.44-5.286-.265-9.973-2.777-13.11-6.595-.548.933-.862 2.014-.862 3.173 0 2.188 1.123 4.12 2.83 5.252-1.04-.032-2.023-.317-2.881-.79-.002.027-.002.052-.002.08 0 3.057 2.194 5.61 5.102 6.189-.534.143-1.094.22-1.676.22-.408 0-.809-.038-1.195-.111.808 2.506 3.158 4.33 5.94 4.382-2.177 1.692-4.917 2.702-7.898 2.702-.516 0-1.02-.028-1.516-.087C2.816 23.952 6.159 25 9.75 25c11.7 0 18.095-9.616 18.095-17.957 0-.273-.005-.545-.017-.815 1.24-.892 2.32-2.002 3.172-3.266-1.142.5-2.366.839-3.653.992 1.314-.783 2.321-2.018 2.797-3.493"}));
}

TwitterIcon.defaultProps = {"viewBox":"0 0 31 25"};

module.exports = TwitterIcon;

TwitterIcon.default = TwitterIcon;
